import { render, staticRenderFns } from "./RelatorioExportacao.vue?vue&type=template&id=b4b3926e&lang=pug"
import script from "./RelatorioExportacao.vue?vue&type=script&lang=js"
export * from "./RelatorioExportacao.vue?vue&type=script&lang=js"
import style0 from "./RelatorioExportacao.vue?vue&type=style&index=0&id=b4b3926e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports